import { render, staticRenderFns } from "./IconImages.vue?vue&type=template&id=a87deac0"
import script from "./IconImages.vue?vue&type=script&lang=js"
export * from "./IconImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports